import { AlertSystem, CreateAlertSystem, GetListResponse } from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _AlertSystemService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<AlertSystem>>(
      "/admin/api/v2/alert-system",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public create(alertSystem: CreateAlertSystem) {
    return HttpService.post("/admin/api/v2/alert-system", {
      body: { ...alertSystem },
    });
  }

  public update(alertSystemId: number, alertSystem: CreateAlertSystem) {
    return HttpService.patch(`/admin/api/v2/alert-system/${alertSystemId}`, {
      body: { ...alertSystem },
    });
  }

  public delete(alertSystemId: number) {
    return HttpService.delete(`/admin/api/v2/alert-system/${alertSystemId}`);
  }
}

const AlertSystemService = new _AlertSystemService();

export default AlertSystemService;
